import React from 'react';
import { connect } from 'react-redux';

import CommonNavItem from '../../Common/CommonNavItem/CommonNavItem';
import HeadingH4 from '../../../UI/Headings/HeadingH4/HeadingH4';

import * as farePriceActions from '../../../../store/actions/index';

const mealsNav = (props) =>  {
    const mealKeys = Object.keys(props.meals).filter((keyCode) => {
        return props.meals[keyCode].mealOptions.length !== 0;
    });
    return (
        <React.Fragment>
            <div className={`mr-6 phone-mb-2`}>
                <HeadingH4 size={11} textUpper={true} weight="Medium" color="Dark">{props.type === 'depart' ? 'Depart' : 'Return'}</HeadingH4>
            </div>
            <nav>
                <ul className={`u-flex`}>
                    { mealKeys.map((meal, index) => {
                        return <CommonNavItem key={meal} onClick={() => props.onToggleMealsView(meal, props.type, index)} active={props.mealsView === meal && (props.flow === props.mealsFlow) ? 'true' : 'false'}>{meal.replace('|', ' - ')}</CommonNavItem>
                    })} 
                </ul>
            </nav>
        </React.Fragment>
    );
}   

const mapDispatchToProps = dispatch => {
    return {
        onToggleMealsView: (view, tripType, index) => dispatch(farePriceActions.toggleMealsView(view, tripType, index))
    }
}

export default connect(null, mapDispatchToProps)(mealsNav);


// WEBPACK FOOTER //
// ./src/components/Addons/Meals/MealsNav/MealsNav.js